
<template>
  <v-app id="searchNeig">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Accommodation properties</v-card-title>
      <v-simple-table dense>
         <tbody v-for="(neigRecord,i) in searchNeig" :key="i">
           <tr @click="$router.reload('/syst/ref/neig/onNeig/' + neigRecord.neig_encrid)">
             <td>{{neigRecord.neig_num}}</td>
             <td>{{neigRecord.neigtaal_oms}}</td>
             <td>{{neigRecord.neigtaal_website}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>   
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchNeig: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/neig/searchNeig.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchNeig"
          },
          searchNeig: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchNeig = res.data.searchNeig;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
